import { useEffect, useRef, useState } from 'react';

/**
 * Whether to show a settings save error that happened while this page is open, even after the
 * save's one conflict retry: once, until closed. An error from before this mount is not shown,
 * so returning to the page does not re-raise it; one that landed while no page showing errors
 * was open goes unseen.
 */
export default function useNewSaveError(saveError) {
  const [open, setOpen] = useState(false);
  const shownRef = useRef(saveError);
  useEffect(() => {
    if (!saveError) {
      setOpen(false);
    } else if (saveError !== shownRef.current) {
      setOpen(true);
    }
    shownRef.current = saveError;
  }, [saveError]);
  return [open, () => setOpen(false)];
}
